import { Navigate } from "react-router-dom";
import { userAccessToken } from "./helpers";

const WithoutAuth = (props) => {
  const token = userAccessToken();

  if (token) {    
    return <Navigate to="/" replace />;
  }

  return <>{props.children}</>;
};

export default WithoutAuth;

